import React from 'react';
import DealCard from '../components/deals/DealCard';
import { deals } from '../data/deals';

const DealsPage = () => {
  return (
    <div className="pt-20">
      <div className="bg-gradient-to-b from-gray-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Bons Plans Étudiants</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
             Des offres et des techniques exclusives vous permettant de profiter pleinement de divers outils digitaux
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {deals.map((deal, index) => (
              <DealCard key={index} deal={deal} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealsPage;